import { BaseModel } from "@/models/base.model"
import { type IRecurringAvailability } from "@/interfaces/api/recurring-availability.interface.ts"
import { type Weekdays, WeekdayLabels } from "@/enums/models/weekdays.ts"
import type { Moment } from "moment"
import type { AvailabilityTypes } from "@/enums/models/availability-types.ts"

export class RecurringAvailability extends BaseModel implements IRecurringAvailability {
  public static className = "RecurringAvailability" // Used for socket communication.
  public static verboseName = "terugkerende beschikbaarheid"

  availabilityBucket: string
  availabilityType: AvailabilityTypes
  dayOfWeek: Weekdays
  timeStart?: Moment | null
  timeEnd?: Moment | null
  isActive: boolean

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor(recurringAvailability: IRecurringAvailability, managed = false) {
    super(recurringAvailability)

    this.availabilityBucket = recurringAvailability.availabilityBucket
    this.availabilityType = recurringAvailability.availabilityType
    this.dayOfWeek = recurringAvailability.dayOfWeek
    this.timeStart = recurringAvailability.timeStart
    this.timeEnd = recurringAvailability.timeEnd
    this.isActive = recurringAvailability.isActive
  }

  public getDayOfWeekDisplay(): string {
    return WeekdayLabels[this.dayOfWeek]
  }

  public isComplete(): boolean {
    return !!this.timeStart && !!this.timeEnd
  }
}
